module.exports = __webpack_public_path__ + "img/Curves.575ae1a3.svg";